module.exports = __webpack_public_path__ + "img/sorry.ede2f1a3.svg";